"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Values only for Customer Center theme
var customerCenterTheme = {
  sliderBorderRadius: '5px',
  sliderRailBg: 'rgba(155, 155, 155, 0.25)',
  sliderTrackBg: 'linear-gradient(0deg, #a8d534 0%, #7db92b 100%)',
  smallSliderBorderRadius: '3px',
  smallSliderRailBg: 'rgba(131, 144, 154, 0.5)',
  navHeight: '68px',
  borderRadius: '16px'
};

// Values only for Datacheck Center theme
var datacheckCenterTheme = {
  sidebarWidth: '250px',
  footerHeight: '64px',
  transitionTime: '0.25s',
  transitionEasing: 'cubic-bezier(0.075, 0.820, 0.165, 1.000)'
};

/*
* If a color is valid for both Customer Center (cc) and
* Datacheck Center (dc), it will be represented by a string,
* if not, it will be represented by an object with the following
* keys: cc and dc.
* */
var theme = _objectSpread(_objectSpread({
  bg: '#f5f8fa',
  bgFaded: 'rgba(245, 248, 250, .5)',
  primary: '#082136',
  primaryFaded: 'rgba(8, 33, 54, 0.5)',
  secondary: {
    cc: '#9b9b9b',
    dc: '#83909a'
  },
  whiteFaded: 'rgba(255, 255, 255, 0.5)',
  accent: '#4694e6',
  accentFaded: 'rgba(70, 148, 230, 0.3)',
  warning: '#f5a623',
  warningFaded: 'rgba(245, 166, 35, 0.3)',
  detail: {
    cc: '#deecf2',
    dc: '#c1c8cd'
  },
  success: {
    cc: '#7db92b',
    dc: '#6cb644'
  },
  successFaded: 'rgba(108, 182, 68, 0.3)',
  danger: '#d0021b',
  disabled: '#bcbcbc',
  selectedDay: 'rgba(227, 180, 2, 0.3)',
  error: '#ab5353',
  errorFaded: 'rgba(171, 83, 83, 0.3)',
  boxShadow: {
    cc: '0 1px 10px 0 rgba(201, 201, 201, 0.5)',
    dc: '0 1px 15px 0 rgba(193, 200, 205, 0.4)'
  }
}, customerCenterTheme), datacheckCenterTheme);
var _default = exports["default"] = theme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/abihome-components/build/styles/theme.js
// module id = 343
// module chunks = 17